export default "__VITE_ASSET__Cmu2JFd1__"